import {
  ApiAddDiscountCodeRequestedAction,
  apiAddDiscountCodeFailed,
  apiAddDiscountCodeSucceeded
} from '@spa/lib/store/api/cart/addDiscountCodeApi';
import addDiscountCodeAction, {
  AddDiscountCodeActionInput,
  AddDiscountCodeActionResult
} from '@spa/lib/actions/cart/addDiscountCodeAction';
import { call, put } from 'typed-redux-saga';

function* addDiscountCodeSaga({
  payload: { actionId: requestedActionId, code, customOrderType, parentActionId }
}: ApiAddDiscountCodeRequestedAction): Generator {
  try {
    const input: AddDiscountCodeActionInput = { customOrderType, code };
    const { cartId, result }: AddDiscountCodeActionResult = yield* call(
      addDiscountCodeAction,
      'addDiscountCodeAction',
      input
    );

    yield* put(
      apiAddDiscountCodeSucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId,
        code
      })
    );
  } catch {
    yield* put(apiAddDiscountCodeFailed({ requestedActionId, parentActionId }));
  }
}

export default addDiscountCodeSaga;
